<template>
  <template v-if="screenType === 'mobile'">
    <VClientFilter v-if="isCollapsed" />
    <div v-else class="mobile-btns">
      <VClientFilter />
    </div>
  </template>
  <VClientFilter v-else />
  <template v-if="isLoaded">
    <RestaurantList v-show="!isCollapsed && !isAuthPage" />
  </template>
  <div
    v-if="screenType === 'mobile' && !isAuthPage && !isCollapsed"
    class="mobile-items"
  >
    <div class="login-mobile" @click="onProfileClickHandler">
      <IconPerson color="#222" />
    </div>

    <div v-if="isAuth" class="ring-btn" @click="$store.commit('toggleNotices')">
      <IconRing />
      <div class="ring_hasItems" v-if="unreadItems">
        <span v-if="unreadItems < 10">{{ unreadItems }}</span>
      </div>
    </div>
  </div>

  <div
    v-if="screenType === 'mobile'"
    class="city-btn"
    @click="onCityClickHandler"
  >
    <CityIcon />
  </div>

  <AuthMobile v-if="isAuthPage" />
</template>

<script>
import RestaurantList from "@/components/pages/restaurants/RestaurantList.vue";
import VClientFilter from "@/components/pages/home/VClientFilter.vue";
import ChangeRoleModal from "@/components/modals/ChangeRoleModal.vue";
import IconPerson from "@/components/icons/IconPerson.vue";
import IconRing from "@/components/icons/IconRing.vue";
import CityIcon from "@/components/icons/CityIcon.vue";
import ChooseCityModal from "@/components/modals/ChooseCityModal.vue";
import AuthMobile from "@/components/pages/home/AuthMobile.vue";

export default {
  name: "RestaurantListPage",
  components: {
    AuthMobile,
    CityIcon,
    IconRing,
    IconPerson,
    VClientFilter,
    RestaurantList,
  },

  data() {
    return {
      isLoaded: false,
    };
  },

  computed: {
    cities() {
      return this.$store.state.general.cities;
    },
    isChangeAccountModalClosed() {
      return this.$store.state.general.isChangeAccountModalClosed;
    },
    city() {
      return this.$store.state.general.city;
    },
    screenType() {
      return this.$store.getters.screenType;
    },
    isAuthPage() {
      return this.$store.state.clientRestaurants.isAuthPage;
    },
    isAuth() {
      return this.$store.state.general.auth.isAuth;
    },
    isCollapsed() {
      return this.$store.state.clientRestaurants.isCollapsed;
    },
    unreadItems() {
      return this.$store.state.notices.unreadItems.length;
    },
  },

  methods: {
    onProfileClickHandler() {
      if (this.isAuth) {
        this.$router.push("/account/settings");
      } else {
        this.$store.commit({
          type: "setIsAuthPage",
          value: true,
        });
      }
    },
    onCityClickHandler() {
      this.$store.dispatch("openModal", {
        value: {
          component: ChooseCityModal,
          props: null,
        },
      });
    },
  },

  async mounted() {
    this.$nextTick(() => {
      if (this.roleGroup === "biz") {
        this.$store.dispatch("openModal", {
          value: {
            component: ChangeRoleModal,
            props: null,
          },
        });
      }
      if (this.$store.state.clientRestaurants.items?.length > 0) {
        this.$store.dispatch("filterRestaurants");
      }
      this.isLoaded = true;
    });
  },

  watch: {
    isChangeAccountModalClosed() {
      this.$store.dispatch("setCities", {
        value: {
          hideRoleCheck: true,
        },
      });
    },
    cities: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.$store.dispatch("setCities");
          });
        }
      },
      deep: true,
      immediate: true,
    },
    city: {
      async handler(val) {
        if (val) {
          this.centerCoords = [val.latitude, val.longitude];
          await this.$store.dispatch("getClientRestaurants", {
            value: { city: val.city, settlement: "" },
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.mobile-btns {
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 156px;
  width: 100%;
  padding: 16px;
  z-index: 1111;
}

.mobile-items {
  position: fixed;
  top: 152px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 111111111;
}

.login-mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 -2px 60px 0 #00000026;
  background-color: #fff;
}

.city-btn {
  position: fixed;
  bottom: 96px;
  right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 -2px 60px 0 #00000026;
  background-color: #fff;
  z-index: 111111111;
}

.ring-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 -2px 60px 0 #00000026;
  background-color: #fff;
  cursor: pointer;
}

.ring_hasItems {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  transform: translate(50%, -50%);
  border-radius: 50%;
  background-color: #f18e35;

  span {
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
}
</style>
